const initialPage = 1;
const initialPageSize = 10;


const initialPagination = {
    pageSize: initialPageSize,
    currentPage: initialPage,
};


const initialFilters = {
    searchFilters: {},
    pagination: initialPagination,
    refreshIndex: 0,
};


export const initialState = {
    referenceTypes: [],
    countries: [],
    items: [],
    totalCount: 0,
    filters: initialFilters,
    loading: true,
    clearLoading: false,
    searchLoading: false,
    itemSelected: null,
    pagination: initialPagination,
    indexVisibility: 0,
    refreshIndex: 0,
};


export const reducer = (state, action) => {
    switch (action.type) {
        case "set_reference_types":
            return { ...state, referenceTypes: action.payload };
        case "set_countries":
            return { ...state, countries: action.payload };
        case "set_items":
            return { ...state, items: action.payload.items, totalCount: action.payload.total };
        case "set_search_filters":
            return {
                ...state, filters: {
                    ...state.filters, searchFilters: action.payload,
                    pagination: { ...state.filters.pagination, currentPage: 1 },
                }
            };
        case "open_view":
            return { ...state, itemSelected: action.payload.item, indexVisibility: action.payload.index };
        case "set_loading":
            return { ...state, loading: action.payload };
        case "set_clear_loading":
            return { ...state, clearLoading: action.payload, loading: action.payload, searchLoading: false };
        case "set_search_loading":
            return { ...state, searchLoading: action.payload, loading: action.payload, clearLoading: false };
        case "set_index_visibility":
            return { ...state, indexVisibility: action.payload };
        case "refresh_list":
            return { ...state, filters: { ...state.filters, refreshIndex: state.filters.refreshIndex + 1 } };
        case "set_table_pagination":
            return { ...state, filters: { ...state.filters, pagination: action.payload } };
        case "set_item_selected":
            return { ...state, itemSelected: action.payload };
        default:
            return state;
    }
};
